import { useState, useEffect } from 'react';
import { api } from '../services/api';
import './SettingsPage.css';

const FALLBACK_FONTS = [
  { key: 'great-vibes', display: 'Great Vibes', webFamily: 'Great Vibes' },
  { key: 'allura',      display: 'Allura',      webFamily: 'Allura' },
  { key: 'sacramento',  display: 'Sacramento',  webFamily: 'Sacramento' },
];

export default function SettingsPage() {
  const [name, setName]   = useState('');
  const [font, setFont]   = useState('allura');
  const [fonts, setFonts] = useState(FALLBACK_FONTS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [saved, setSaved]     = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    Promise.all([
      api.get('/auth/me'),
      api.get('/contracts/signature-fonts').catch(() => null),
    ]).then(([me, opts]) => {
      setName(me.signatureName || me.name || '');
      setFont(me.signatureFont || 'allura');
      if (opts && opts.length) setFonts(opts);
      setLoading(false);
    }).catch(e => { setError(e.message); setLoading(false); });
  }, []);

  const family = (key) => {
    const f = fonts.find(x => x.key === key) || fonts[0];
    return `'${f?.webFamily || 'Allura'}', cursive`;
  };

  async function handleSave() {
    if (!name.trim()) { setError('Enter the name to use on your signature.'); return; }
    setSaving(true);
    setError(null);
    setSaved(false);
    try {
      await api.put('/auth/signature', { name: name.trim(), font });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="settings-page"><div className="settings-loading">Loading…</div></div>;

  return (
    <div className="settings-page">
      <h2 className="settings-title">My Signature</h2>
      <p className="settings-sub">
        This is auto-applied as the consultant signature on every contract your clients sign.
      </p>

      {error && <div className="settings-error">{error}</div>}

      <div className="settings-card">
        <label className="settings-field">
          <span>Name on signature</span>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Phillip Burt" />
        </label>

        <div className="settings-preview-label">Preview</div>
        <div className="settings-preview" style={{ fontFamily: family(font) }}>
          {name.trim() || 'Your signature'}
        </div>

        <div className="settings-font-grid">
          {fonts.map(f => (
            <button
              key={f.key}
              type="button"
              className={`settings-font-card ${font === f.key ? 'selected' : ''}`}
              onClick={() => setFont(f.key)}
            >
              <span className="settings-font-sample" style={{ fontFamily: `'${f.webFamily}', cursive` }}>
                {name.trim() || 'Signature'}
              </span>
              <span className="settings-font-name">{f.display}</span>
            </button>
          ))}
        </div>

        <div className="settings-actions">
          {saved && <span className="settings-saved">✓ Saved</span>}
          <button className="settings-save" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Save signature'}
          </button>
        </div>
      </div>
    </div>
  );
}
